import React from 'react';
import { Helmet } from 'react-helmet';
import { seoConfig } from '../config/seo';

const SEO = ({ page, title, description, keywords, structuredData }) => {
    const pageConfig = seoConfig.pages[page] || {};
    
    const finalTitle = title || pageConfig.title || seoConfig.defaultTitle;
    const finalDescription = description || pageConfig.description || seoConfig.defaultDescription;
    const finalKeywords = keywords || pageConfig.keywords || seoConfig.defaultKeywords;

    return (
        <Helmet>
            <title>{finalTitle}</title>
            <meta name="description" content={finalDescription} />
            <meta name="keywords" content={finalKeywords} />
            <meta name="author" content="养花怪兽儿童阅读馆" />
            <meta name="language" content="Chinese" />
            
            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:site_name" content="养花怪兽儿童阅读馆" />
            
            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@yanghuaguaishou" />
            <meta name="twitter:creator" content="@yanghuaguaishou" />
            
            {/* 结构化数据 */}
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO; 